import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { catchError, defaultIfEmpty, shareReplay, tap } from "rxjs/operators";
import { AuthenticationResponse } from "@models/account/account.model";
import { ApiService } from "./api.service";
import { UserHelperService } from "./userHelper.service";

export interface FeatureFlags {
  emotionTransfer: boolean; // effective value: global feature flag AND user setting
  emotionTransferFeatureEnabled: boolean; // global feature flag
}

/**
 * The flags stored in the session at login can be outdated (feature disabled after login),
 * so they are fetched again from the API on app load and after each login.
 */
@Injectable({
  providedIn: "root",
})
export class FeatureFlagService {
  private flags$: Observable<FeatureFlags> | null = null;

  constructor(
    private api: ApiService,
    private userHelperService: UserHelperService
  ) {}

  public refresh(): Observable<FeatureFlags> {
    this.flags$ = this.api.get("account/features").pipe(
      tap((flags: FeatureFlags) =>
        this.userHelperService.updateCurrentUserFeatureFlags(flags)
      ),
      // keep the values stored at login if the call fails
      defaultIfEmpty(this.getSessionFlags()),
      catchError(() => of(this.getSessionFlags())),
      shareReplay(1)
    );
    return this.flags$;
  }

  public getFlags(): Observable<FeatureFlags> {
    return this.flags$ || this.refresh();
  }

  private getSessionFlags(): FeatureFlags {
    const token = localStorage.getItem("session");
    const session = token
      ? (JSON.parse(token) as AuthenticationResponse)
      : null;
    console.log(
      "!!session?.emotionTransferFeatureEnabled",
      !!session?.emotionTransferFeatureEnabled
    );
    console.log("!!session?.emotionTransfer", !!session?.emotionTransfer);
    return {
      emotionTransfer: !!session?.emotionTransfer,
      emotionTransferFeatureEnabled: !!session?.emotionTransferFeatureEnabled,
    };
  }
}
